<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-divider>{{ $T('签证邀请信息') }}</el-divider>
      <div class="visa-reference-tips">
        <p class="visa-reference-tips__title">{{ $T('签证政策参考') }}</p>
        <ul class="visa-reference-tips__list">
          <li>
            <a
              :href="visaRefLinks.mutualExemption"
              target="_blank"
              rel="noopener noreferrer"
            >{{ $T('签证参考互免协定一览') }}</a>
          </li>
          <li>
            <a
              :href="visaRefLinks.unilateralFaq"
              target="_blank"
              rel="noopener noreferrer"
            >{{ $T('签证参考单方面免签') }}</a>
          </li>
        </ul>
      </div>
      <div class="actions">
        <el-button type="primary" icon="el-icon-plus" @click="openVisaDialog()">{{ $T('添加签证') }}</el-button>
      </div>

      <el-table :data="visaList" border stripe size="mini" style="width: 100%" :empty-text="$T('暂无数据')">
        <el-table-column :label="$T('姓')" min-width="110">
          <template slot-scope="scope">{{ nameSurname(scope.row.name) }}</template>
        </el-table-column>
        <el-table-column :label="$T('名')" min-width="120">
          <template slot-scope="scope">{{ nameGiven(scope.row.name) }}</template>
        </el-table-column>
        <el-table-column :label="$T('性别')" min-width="90">
          <template slot-scope="scope">{{ sexLabel(scope.row.sex) }}</template>
        </el-table-column>
        <el-table-column prop="passport_number" :label="$T('护照号码')" min-width="140"></el-table-column>
        <el-table-column prop="pass_expiry_date" :label="$T('护照到期日')" min-width="150"></el-table-column>
        <el-table-column prop="city_to_apply" :label="$T('申请城市')" min-width="120"></el-table-column>
        <el-table-column prop="arrival_date" :label="$T('抵达日期')" min-width="120"></el-table-column>
        <el-table-column prop="departure_date" :label="$T('离境日期')" min-width="130"></el-table-column>
        <el-table-column :label="$T('照片')" min-width="90">
          <template slot-scope="scope">
            <span>{{ fileCount(scope.row.photo) > 0 ? $T('已上传') : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$T('护照PDF')" min-width="100">
          <template slot-scope="scope">
            <span>{{ fileCount(scope.row.pass_pdf) > 0 ? $T('已上传') : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$T('操作')" width="140" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="openVisaDialog(scope.row, scope.$index)">{{ $T('编辑') }}</el-button>
            <el-button type="text" style="color: #f56c6c" @click="removeVisa(scope.$index)">{{ $T('删除') }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="footer-button">
        <el-button type="primary" :loading="saveLoading" @click="onNext">{{ $T('下一步') }}</el-button>
      </div>

      <el-dialog :title="editingIndex > -1 ? $T('编辑签证邀请') : $T('新增签证邀请')" :visible.sync="showDialog" width="720px" @closed="onDialogClosed">
        <el-form :model="visaForm" :rules="visaRules" ref="visaFormRef" label-position="top" class="visa-dialog-form">
          <el-row :gutter="12">
            <el-col :span="12">
              <el-form-item :label="$T('姓')" prop="surname">
                <el-input style="width: 300px;" v-model="visaForm.surname" :placeholder="$T('请输入姓')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$T('名')" prop="given_name">
                <el-input style="width: 300px;" v-model="visaForm.given_name" :placeholder="$T('请输入名')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="12">
            <el-col :span="12">
              <el-form-item :label="$T('出生日期')" prop="birthday">
                <el-date-picker style="width: 300px;" v-model="visaForm.birthday" type="date" value-format="yyyy-MM-dd"  ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$T('性别')" prop="sex">
                <el-radio-group style="width: 300px;" v-model="visaForm.sex">
                  <el-radio :label="1">{{ $T('男') }}</el-radio>
                  <el-radio :label="2">{{ $T('女') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="12">
            <el-col :span="12">
              <el-form-item :label="$T('护照号码')" prop="passport_number">
                <el-input style="width: 300px;" v-model="visaForm.passport_number" :placeholder="$T('请输入护照号码')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$T('护照到期日')" prop="pass_expiry_date">
                <el-date-picker   v-model="visaForm.pass_expiry_date" type="date" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="12">
            <el-col :span="12">
              <el-form-item :label="$T('申请城市')" prop="city_to_apply">
                <el-input style="width: 300px;" v-model="visaForm.city_to_apply" :placeholder="$T('请输入申请城市')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$T('抵达日期')" prop="arrival_date">
                <el-date-picker   v-model="visaForm.arrival_date" type="date" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="12">
            <el-col :span="12">
              <el-form-item :label="$T('离境日期')" prop="departure_date">
                <el-date-picker v-model="visaForm.departure_date" type="date" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item :label="$T('照片')">
            <PicUploader :fileList="visaForm.photo" :limit="3"></PicUploader>
          </el-form-item>
          <el-form-item :label="$T('护照PDF')">
            <FileUploader :fileList="visaForm.pass_pdf" :limit="3" accept=".pdf"></FileUploader>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="showDialog = false">{{ $T('取消') }}</el-button>
          <el-button type="primary" @click="confirmVisa">{{ $T('确定') }}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<style scoped>
.visa-reference-tips {
  margin-bottom: 12px;
  padding: 10px 12px;
  background: #f4f4f5;
  border-radius: 4px;
  font-size: 13px;
  color: #606266;
}
.visa-reference-tips__title {
  margin: 0 0 8px;
  font-weight: 600;
  color: #303133;
}
.visa-reference-tips__list {
  margin: 0;
  padding-left: 18px;
}
.visa-reference-tips__list li {
  margin-bottom: 6px;
  line-height: 1.5;
}
.visa-reference-tips__list li:last-child {
  margin-bottom: 0;
}
.visa-reference-tips a {
  color: #409eff;
  text-decoration: none;
}
.visa-reference-tips a:hover {
  text-decoration: underline;
}
.actions {
  margin-bottom: 12px;
}
.footer-button {
  margin-top: 16px;
  text-align: center;
}
.visa-dialog-form /deep/ .el-form-item__label {
  line-height: 20px;
  padding-bottom: 6px;
}
.visa-dialog-form /deep/ .el-form-item__content {
  margin-left: 0 !important;
}
</style>

<script>
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';

const VISA_REF_LINKS = {
  mutualExemption: 'https://cs.mfa.gov.cn/wgrlh/lhqz/lhqzjjs/202510/t20251023_11739051.shtml',
  unilateralFaq: 'https://cs.mfa.gov.cn/gyls/lsgz/fwxx/202511/t20251110_11749824.shtml',
};

const buildNameFromParts = (surname, given) => {
  const s = (surname || '').trim();
  const g = (given || '').trim();
  if (s && g) {
    return s + ' ' + g;
  }
  return s || g || '';
};

const splitNameToParts = (name) => {
  const full = (name || '').trim();
  if (!full) {
    return { surname: '', given_name: '' };
  }
  const idx = full.indexOf(' ');
  if (idx === -1) {
    return { surname: full, given_name: '' };
  }
  return {
    surname: full.slice(0, idx).trim(),
    given_name: full.slice(idx + 1).trim(),
  };
};

const createEmptyVisaForm = () => ({
  surname: '',
  given_name: '',
  birthday: '',
  sex: 1,
  passport_number: '',
  pass_expiry_date: '',
  city_to_apply: '',
  arrival_date: '',
  departure_date: '',
  photo: [],
  pass_pdf: [],
});

export default {
  name: 'SaiApplyFormStep6',
  components: {
    PicUploader,
    FileUploader,
  },
  data() {
    return {
      saveLoading: false,
      formData: {
        id: 0,
      },
      visaList: [],
      showDialog: false,
      editingIndex: -1,
      visaForm: createEmptyVisaForm(),
      visaRefLinks: VISA_REF_LINKS,
    };
  },
  computed: {
    visaRules() {
      return {
        surname: [{ required: true, message: this.$T('请输入姓'), trigger: 'blur' }],
        given_name: [{ required: true, message: this.$T('请输入名'), trigger: 'blur' }],
        birthday: [{ required: true, message: this.$T('请选择出生日期'), trigger: 'change' }],
        sex: [{ required: true, message: this.$T('请选择性别'), trigger: 'change' }],
      };
    },
  },
  mounted() {
    this.formData.id = this.$route.query.id;
    document.title = this.$T('签证邀请');
    if (this.formData.id) {
      this.fetch();
    }
  },
  methods: {
    fetch() {
      this.$api.post(
        '/api/isai/step6detail',
        { id: this.formData.id },
        (res) => {
          const data = res.data || {};
          const list = data.visa_list || [];
          this.visaList = list.map((item) => ({
            id: item.id || 0,
            name: item.name || '',
            birthday: item.birthday || '',
            sex: Number(item.sex) === 2 ? 2 : 1,
            passport_number: item.passport_number || '',
            pass_expiry_date: item.pass_expiry_date || '',
            city_to_apply: item.city_to_apply || '',
            arrival_date: item.arrival_date || '',
            departure_date: item.departure_date || '',
            photo: Array.isArray(item.photo) ? item.photo : [],
            pass_pdf: Array.isArray(item.pass_pdf) ? item.pass_pdf : [],
          }));
        },
        (res) => {
          this.$message.error(res.msg || this.$T('加载失败'));
        },
      );
    },
    nameSurname(name) {
      return splitNameToParts(name).surname;
    },
    nameGiven(name) {
      return splitNameToParts(name).given_name;
    },
    sexLabel(sex) {
      return Number(sex) === 2 ? this.$T('女') : this.$T('男');
    },
    fileCount(list) {
      return Array.isArray(list) ? list.length : 0;
    },
    openVisaDialog(row, index) {
      if (row !== undefined && index !== undefined) {
        this.editingIndex = index;
        const parts = splitNameToParts(row.name);
        this.visaForm = {
          surname: parts.surname,
          given_name: parts.given_name,
          birthday: row.birthday || '',
          sex: Number(row.sex) === 2 ? 2 : 1,
          passport_number: row.passport_number || '',
          pass_expiry_date: row.pass_expiry_date || '',
          city_to_apply: row.city_to_apply || '',
          arrival_date: row.arrival_date || '',
          departure_date: row.departure_date || '',
          photo: Array.isArray(row.photo) ? row.photo.slice() : [],
          pass_pdf: Array.isArray(row.pass_pdf) ? row.pass_pdf.slice() : [],
        };
      } else {
        this.editingIndex = -1;
        this.visaForm = createEmptyVisaForm();
      }
      this.showDialog = true;
      this.$nextTick(() => {
        if (this.$refs.visaFormRef) {
          this.$refs.visaFormRef.clearValidate();
        }
      });
    },
    onDialogClosed() {
      this.editingIndex = -1;
    },
    confirmVisa() {
      this.$refs.visaFormRef.validate((valid) => {
        if (!valid) {
          return;
        }
        const name = buildNameFromParts(this.visaForm.surname, this.visaForm.given_name);
        const row = {
          id: this.editingIndex > -1 ? this.visaList[this.editingIndex].id : 0,
          name: name,
          birthday: this.visaForm.birthday,
          sex: this.visaForm.sex,
          passport_number: (this.visaForm.passport_number || '').trim(),
          pass_expiry_date: this.visaForm.pass_expiry_date || '',
          city_to_apply: (this.visaForm.city_to_apply || '').trim(),
          arrival_date: this.visaForm.arrival_date || '',
          departure_date: this.visaForm.departure_date || '',
          photo: Array.isArray(this.visaForm.photo) ? this.visaForm.photo.slice() : [],
          pass_pdf: Array.isArray(this.visaForm.pass_pdf) ? this.visaForm.pass_pdf.slice() : [],
        };
        const wasEdit = this.editingIndex > -1;
        if (wasEdit) {
          this.visaList.splice(this.editingIndex, 1, row);
        } else {
          this.visaList.push(row);
        }
        this.showDialog = false;
        this.$message.success(wasEdit ? this.$T('已更新') : this.$T('已添加'));
      });
    },
    removeVisa(index) {
      this.visaList.splice(index, 1);
    },
    onNext() {
      for (let i = 0; i < this.visaList.length; i++) {
        const row = this.visaList[i];
        const n = i + 1;
        const name = (row.name || '').trim();
        if (!name) {
          this.$message.warning(this.$T('请完善姓名') + ' (' + n + ')');
          return;
        }
        if (!row.birthday) {
          this.$message.warning(this.$T('请完善出生日期') + ' (' + n + ')');
          return;
        }
        if (Number(row.sex) !== 1 && Number(row.sex) !== 2) {
          this.$message.warning(this.$T('请选择性别') + ' (' + n + ')');
          return;
        }
      }
      const payload = this.visaList.map((row) => ({
        name: (row.name || '').trim(),
        birthday: row.birthday || '',
        sex: Number(row.sex) === 2 ? 2 : 1,
        passport_number: (row.passport_number || '').trim(),
        pass_expiry_date: row.pass_expiry_date || '',
        city_to_apply: (row.city_to_apply || '').trim(),
        arrival_date: row.arrival_date || '',
        departure_date: row.departure_date || '',
        photo: Array.isArray(row.photo) ? row.photo : [],
        pass_pdf: Array.isArray(row.pass_pdf) ? row.pass_pdf : [],
      }));
      this.saveLoading = true;
      this.$api.post(
        '/api/isai/visaSave',
        {
          baoming_id: this.formData.id,
          visa_list: JSON.stringify(payload),
        },
        () => {
          this.saveLoading = false;
          this.$message.success(this.$T('保存成功')); 
          rbLink({
            name: 'ISaiApplyDetail',
            query: {
              id: this.formData.id,
            },
          }, 'back');
        },
        (res) => {
          this.saveLoading = false;
          this.$message.error(res.msg || this.$T('保存失败'));
        },
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// SaiApplyFormStep6.vue?123ddd71